module.exports = __webpack_public_path__ + "images/file_icons_v2/rar-8c755e094b565fdc2676c8c3dc2b03fd.svg";